module.exports = __webpack_public_path__ + "pound.085554ea.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/media/eco-token/pound.png
// module id = 2610
// module chunks = 0